import React from 'react';
import PropTypes from 'prop-types';
import Document, { Html, Head } from 'next/document';
import DocumentBody from './DocumentBody';
import { renderAppleTags } from '../../helpers';

const DEFAULT_LANG = (process.env.BLAZE_TRANSLATION_LANGUAGE || 'en').replace('_', '-');

const BlazeDocument = ({ children, lang = DEFAULT_LANG }) => (
  <Html lang={lang}>
    <Head>
      <link rel="icon" href="/static/img/favicon.png" type="image/x-icon" />
      {renderAppleTags()}
    </Head>
    {children}
  </Html>
);

BlazeDocument.Document = Document;
BlazeDocument.Body = DocumentBody;

BlazeDocument.propTypes = {
  children: PropTypes.object.isRequired,
  lang: PropTypes.string
};

BlazeDocument.defaultProps = {
  lang: DEFAULT_LANG
};

export default BlazeDocument;
